import { Box, Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PendingRoleIntentsBanner } from "Components/Roles/PendingRoleIntentsBanner";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsMobile } from "Hooks/useIsMobile";
import { Resources, useResource } from "Translations/Resources";

/**
 * Deliberately minimal: a Disponent holds no access rights yet, so every customer-dashboard
 * section (balance, transactions, stories, earnings) would fail its right-gated request. Only
 * role-neutral content is shown; sections are added here as the role gains rights.
 */
export const DisponentDashboardPage = () => {
  const isMobile = useIsMobile();
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Dashboard)}
      isTitleHiddenBelowLgScreen
      isPaddingDisabled={isMobile}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <Stack mb={6} mx={isMobile ? 1 : 0} gap={isMobile ? 2 : 1}>
            <PendingRoleIntentsBanner />
          </Stack>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default DisponentDashboardPage;
